export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 50,
};